const diagonal = [
  0,
  198,
  380,
  546,
  696,
  830,
  948,
  1050,
  1136,
  1206,
  1260,
  1298,
  1320,
]

export const ALLIN_COLORS = ['ALLIN', 'ALL-IN']

export const matrix = {}

diagonal.forEach((item) => {
  const index = diagonal.indexOf(item)
  for (let i = index; i <= 12; i++) {
    for (let j = index; j <= 12; j++) {
      matrix[`${i} ${j}`] =
        item +
        (i === index + 1 ? 3 : 4) * (i - index) +
        (i > index + 1 ? -1 : 0)
      if (j !== i) matrix[`${j} ${i}`] = matrix[`${i} ${j}`] + 1
    }
  }
})

export const cards = [
  'A',
  'K',
  'Q',
  'J',
  'T',
  '9',
  '8',
  '7',
  '6',
  '5',
  '4',
  '3',
  '2',
]

export const adjustPosition = (position) => {
  switch (position) {
    case 'UTG+2':
      return 'LJ'
    case 'UTG+3':
      return 'HJ'
    // case "UTG+4":
    //   return "HJ";
    default:
      return position
  }
}

export const IP_PRIORITY = ['SB', 'BB', 'UTG', 'UTG+1', 'LJ', 'HJ', 'CO', 'BTN']

export const POSITION_ORDER = [
  'SB',
  'BB',
  'UTG',
  'UTG+1',
  'LJ',
  'HJ',
  'CO',
  'BTN',
]

const BETS_POINTS_TOURNEY = {
  80: [2.5, { ip: 3, oop: 4 }, { ip: 2.5, oop: 3 }, 'allin', 'allin'],
  60: [2.2, { ip: 2.7, oop: 3.5 }, { ip: 2.5, oop: 3 }, 'allin', 'allin'],
  40: [2.2, { ip: 2.7, oop: 3.2 }, { ip: 2.2, oop: 2.5 }, 'allin', 'allin'],
  30: [2.2, { ip: 2.7, oop: 3.2 }, 'allin', 'allin', 'allin'],
  25: [2.2, { ip: 2.5, oop: 3.5 }, 'allin', 'allin', 'allin'],
  20: [2.2, { ip: 2.5, oop: 3 }, 'allin', 'allin', 'allin'],
  15: [2, 'allin', 'allin', 'allin', 'allin'],
  12: [2, 'allin', 'allin', 'allin', 'allin'],
  10: [2, 'allin', 'allin', 'allin', 'allin'],
}

const BETS_POINTS_CASH = {
  100: [3, { ip: 3.33, oop: 4 }, { ip: 2.25, oop: 2.7 }, 'allin', 'allin'],
  150: [3, { ip: 3.33, oop: 4 }, { ip: 2.25, oop: 2.7 }, 'allin', 'allin'],
  200: [3, { ip: 3.33, oop: 4 }, { ip: 2.25, oop: 2.7 }, 'allin', 'allin'],
}

const BETS_POINTS_HU = {
  75: [2.5, { ip: 3, oop: 4 }, { ip: 2.3, oop: 2.5 }, "allin", "allin"],
  50: [2.5, { ip: 3, oop: 4 }, { ip: 10, oop: 2.5 }, "allin", "allin"],
  35: [2, { ip: 2.5, oop: 4 }, { ip: 10, oop: 10 }, "allin", "allin"],
  27: [2, { ip: 10, oop: 3.5 }, "allin", "allin", "allin"],
  20: [2, { ip: 10, oop: 3 }, "allin", "allin", "allin"],
  15: [2, "allin", "allin", "allin", "allin"],
  10: [2, "allin", "allin", "allin", "allin"],
};

const BETS_POINTS_HU_ANTE = {
  75: [4, { ip: 2.2, oop: 3 }, { ip: 2.2, oop: 2.4 }, "allin", "allin"],
  50: [3.5, { ip: 2.2, oop: 3 }, { ip: 10, oop: 2.2 }, "allin", "allin"],
  35: [3, { ip: 2.3, oop: 2.7 }, { ip: 10, oop: 10 }, "allin", "allin"],
  27: [2.2, { ip: 10, oop: 3.2 }, "allin", "allin", "allin"],
  20: [2.2, { ip: 10, oop: 3 }, "allin", "allin", "allin"],
  15: ["allin", "allin", "allin", "allin", "allin"],
  10: ["allin", "allin", "allin", "allin", "allin"],
};

export const BETS_POINTS = {
  'MTTs Full Ring': BETS_POINTS_TOURNEY,
  'Cash Game 8max': BETS_POINTS_CASH,
  "MTTs HU NEW": BETS_POINTS_HU,
  "MTTs HU NEW ANTE": BETS_POINTS_HU_ANTE,
}
export const allPositions = [
  'SB',
  'BB',
  'UTG',
  'UTG+1',
  'UTG+2',
  'UTG+3',
  'UTG+4',
  'LJ',
  'HJ',
  'CO',
  'BTN',
]

export const SB_LIMP_BETS = {
  80: 3.5,
  60: 3.5,
  40: 3,
  30: 3,
  25: 3,
  20: 2.7,
  15: 2.7,
  12: 2.4,
  10: 2.4,
}

export const SB_RFI_BETS = {
  80: 4,
  60: 3.5,
  40: 3.5,
  30: 3,
  25: 3,
  20: 2.75,
  15: 2.75,
  12: 2.5,
  10: 2.5,
}

// If frequency is 40-49% = 9 points
// If frequency is 35-39% = 8 points
// If frequency is 30-34% = 7 points
// If frequency is 25-29% = 6 points
// If frequency is 20-24% = 5 points
// If frequency is 15-19% = 4 points
// If frequency is 10-14% = 3 points
// If frequency is 5-9% = 2 points
// If frequency is 1-5% = 1 point
// If frequency is 0% = 0 points

export const ANSWER_POINTS = {
  '50': 10,
  '40': 9,
  '35': 8,
  '30': 8,
  '25': 6,
  '20': 5,
  '15': 4,
  '10': 3,
  '5': 2,
  '1': 1,
  '0': 0,
}

export const calculateAnswerPoints = (percentage) => {
  if (percentage >= 50) return 10
  if (percentage >= 40) return 9
  if (percentage >= 35) return 8
  if (percentage >= 30) return 7
  if (percentage >= 25) return 6
  if (percentage >= 20) return 5
  if (percentage >= 15) return 4
  if (percentage >= 10) return 3
  if (percentage >= 5) return 2
  if (percentage >= 1) return 1
  return 0
}

export const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1) + min) //The maximum is inclusive and the minimum is inclusive
}

export const calculateBets = (
  filename,
  {
    position: hero,
    oppPosition: opponent,
    vsAction,
    stackDepth,
    chartType: type,
  },
  { chart, setLoading, setPlayersBets },
) => {
  const checkIfInPosition = (position, oppPosition) => {
    const opponent = oppPosition || 'SB'

    return IP_PRIORITY.indexOf(position) > IP_PRIORITY.indexOf(opponent)
  }

  const isHero = (position) => {
    return position === hero
  }

  const stackSizeValue = parseInt(stackDepth)

  const fileStringData = filename.split('/')
  const orderString = fileStringData[fileStringData.length - 1]
  const positions = orderString
    .split('_')
    .filter((position) => allPositions.includes(position))

  const adjustedPositions = positions.map((position) =>
    adjustFilenamePositions(position, stackDepth),
  )

  const bets = {
    BB: [1],
    SB: [0.5],
  }

  adjustedPositions.forEach((position, index) => {
    if (index === adjustedPositions.length - 1) return

    const opponent = adjustedPositions[index - 1] || null
    const ip = checkIfInPosition(position, opponent)
    const ipString = ip ? 'ip' : 'oop'
    const sizeToCheck = stackDepth || stackSizeValue
    const typeToCheck = type || chart.type
    let currentBet = !type.toLowerCase().includes('bvb')
      ? BETS_POINTS[typeToCheck][sizeToCheck][index]
      : 0

    if (currentBet[ipString]) {
      if (
        !isHero(position) &&
        vsAction
          .replace(/[^a-zA-Z0-9]/g, '')
          .toUpperCase()
          .includes('ALLIN') &&
        index >= adjustedPositions.length - 2
      ) {
        console.log(position)
      } else {
        currentBet =
          currentBet[ipString] *
          (bets[opponent][bets[opponent].length - 1] || 0)
      }
    }

    if (
      position === 'SB' &&
      index === 0 &&
      !filename.toUpperCase().includes('SB_CALL')
    ) {
      bets[position] = [SB_RFI_BETS[stackSizeValue]]
    } else if (filename.toUpperCase().includes('SB_CALL') && index <= 1) {
      if (position !== 'SB') currentBet = SB_LIMP_BETS[stackSizeValue]
      if (position === 'SB') currentBet = 1
      bets[position] = [currentBet]
    } else if (
      (currentBet === 'allin' && !isHero(position)) ||
      (!isHero(position) &&
        vsAction
          .replace(/[^a-zA-Z0-9]/g, '')
          .toUpperCase()
          .includes('ALLIN') &&
        index >= adjustedPositions.length - 2)
    ) {
      bets[position] = [stackSizeValue]
    } else {
      bets[position] = [currentBet]
    }

    if (bets[position].includes('allin')) bets[position] = [stackSizeValue]
  })

  let totalBets
  for (let index in [...new Set(adjustedPositions)]) {
    totalBets = Object.keys(bets).reduce((acc, curr) => {
      acc[curr] = bets[curr]?.reduce((a, b) => a + b, 0) || 0
      if (acc[curr] > stackSizeValue * 0.4) acc[curr] = stackSizeValue
      return acc
    }, {})
  }
  setPlayersBets(totalBets)

  const oppPosition = adjustPosition(opponent)
  let action
  if (bets[oppPosition] === stackSizeValue) {
    action = 'All-In'
  } else {
    action = vsAction?.replace('VS', '')

    if (action?.trim() === 'ALLIN') action = 'All-In'
  }

  setLoading(false)
}

export const adjustFilenamePositions = (pos, stackSize) => {
  if (stackSize === 30 || stackSize === 40) {
    switch (pos) {
      case 'UTG+2':
        return 'LJ'
      case 'UTG+3':
        return 'HJ'
      // case "UTG":
      //   return null
      default:
        return pos
    }
  } else {
    switch (pos) {
      case 'UTG+1':
        return 'UTG'
      case 'UTG+2':
        return 'UTG+1'
      case 'UTG+3':
        return 'LJ'
      case 'UTG+4':
        return 'HJ'
      // case "UTG":
      //   return null
      default:
        return pos
    }
  }
}

export const getMatrixActions = async (chartUrl, actions) => {
  const extractSubstring = (string, prefix, suffix) => {
    let extracted = string
    const prefixIndex = extracted.indexOf(prefix)
    if (prefixIndex >= 0) {
      extracted = extracted.substring(prefixIndex + prefix.length)
    } else {
      return ''
    }
    if (suffix) {
      const suffixIndex = extracted.indexOf(suffix)
      if (suffixIndex >= 0) {
        extracted = extracted.substring(0, suffixIndex)
      } else {
        const lastIndex = extracted.length - 1
        if (lastIndex >= 0) {
          extracted = extracted.substring(0, lastIndex)
        }
      }
    }
    return extracted
  }

  try {
    const response = await fetch(
      `https://s3.amazonaws.com/poker-coaching/preflop_charts/${encodeURI(
        chartUrl,
      )
        .split('+')
        .join('%2B')}`,
      {
        method: 'GET',
      },
    )
    const data = await response.text()
    const availableActions = JSON.parse(actions)
    const actionsData = {}
    const outOfRange = []

    for (const actionKey of availableActions) {
      const matrix = extractSubstring(data, actionKey, 'True')
      actionsData[actionKey] = matrix.split(' ').reverse()

      const matrixArray = matrix.split(' ').reverse()
      for (const key in matrixArray) {
        outOfRange[key] = (outOfRange[key] || 0) + parseFloat(matrixArray[key])
      }
    }

    const outOfRangeAction = outOfRange.map((item) => 1 - item)
    const hasFoldAction =
      availableActions.includes('Fold') || availableActions.includes('FOLD')

    actionsData[hasFoldAction ? 'OoR' : 'Fold'] = outOfRangeAction

    return actionsData
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export const getActionLabel = (item) => {
  const action = item.toLowerCase()
  if (action.includes('%')) return 'Raise'
  if (action.includes('bb')) return 'Raise'
  return item.replace(/[0-9]/g, '')
}
